import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class ProgramsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = "/api/programs";
    return this.CommonAPIService.getCall(url, "", router);
  }

  create(params, router) {
    const url = "/api/programs";
    return this.CommonAPIService.postCall(url, params, router);
  }
  delete(id, router) {
    const url = `/api/programs/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  update(program_id, params, router) {
    const url = `/api/programs/${program_id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  getProgramsById(id, router) {
    const url = `/api/programs/${id}`;
    return this.CommonAPIService.getCall(url, "", router);
  }
}
export default ProgramsAPIService;
